import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Card, Grid, CardMedia, CardContent, CardActionArea } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardMedia: {
        paddingTop: '56.25%', // 16:9
    },
    cardContent: {
        flexGrow: 1,
    },
}))


const Products = ({product}) => {
    const classes = useStyles();
    return(
        <Grid item xs={12} sm={6} md={3}>
          <Card className={classes.card}>
          <CardActionArea>
              <CardMedia
            component="img"
            alt="Contemplative Reptile"
            height="170"
            image="https://source.unsplash.com/fcnbIO5axMI"
            title={product.name}
          />
            <CardContent className={classes.cardContent}>
              <Typography gutterBottom variant="h5" component="h2">
                {product.name}
              </Typography>
              <Typography variant="subtitle2">
                {product.category}
              </Typography>
              <Typography variant="subtitle2" color="textSecondary">
                  Brand: {product.brand}
              </Typography>
              <Typography variant="subtitle1" color="textSecondary">
                  {product.price ? (`Price: NGN ${product.price}`) : (`Price not available yet`) }
              </Typography>
            </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
    )

}

export default Products